import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class NotificationDetailsService {

    constructor(
        private http: HttpClient
    ) { }

    getById(notificationId) {
        return this.http.get(environment.serverUrl + '/notification/getById/' + notificationId);
    }
    getSubmittedFormPreviewHtml(taskId) {
        return this.http.get(environment.serverUrl + '/task/preview/' + taskId);
    }
}



// WEBPACK FOOTER //
// ./src/app/notification-details/notification-detatils.service.ts